export default "__VITE_ASSET__15sYQiBO__"